import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _fo-y" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "gfu-link-underline__content" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "gfu-link-underline__content" }
const _hoisted_6 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "gfu-link gfu-link-underline _mr-3",
      href: $props.projectUrl,
      "data-qa": "product-breadcrumb:Project"
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString($props.projectName), 1 /* TEXT */),
      _createVNode(_component_base_icon, {
        name: "chevron-right",
        class: "_ml-3 _tc--accent"
      })
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("a", {
      class: "gfu-link gfu-link-underline _mr-3",
      href: $props.categoryUrl,
      "data-qa": "product-breadcrumb:Category"
    }, [
      _createElementVNode("span", _hoisted_5, _toDisplayString($props.categoryName), 1 /* TEXT */),
      _createVNode(_component_base_icon, {
        name: "chevron-right",
        class: "_ml-3 _tc--accent"
      })
    ], 8 /* PROPS */, _hoisted_4),
    _createElementVNode("a", {
      class: "gfu-link",
      href: $props.productUrl,
      "data-qa": "product-breadcrumb:Product"
    }, [
      _createElementVNode("span", null, _toDisplayString($props.productName), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_6)
  ]))
}